<template>
  <div class="wrapper bg-grey-lightest">
    <div class="main-content-wrap">
      <div class="main-content-pannel">
        <div class="new-project-message-wrapper" v-if="first && project">
          <NewProjectMessage :url="url" @onClose="onCloseMessage" />
        </div>
        <div
          class="option-wrap bg-grey-lightest grey-bg-option no-border"
          style="height: 54px; margin-top: 24px"
        >
          <div class="options">
            <div class="content-title-wrap p-t-0">
              <div class="main-content-title">
                {{ project ? project.title : "" }}
              </div>
            </div>
          </div>
        </div>
        <div class="main-flex" v-if="project">
          <div class="main-flex-1">
            <div class="pannel-1">
              <div class="pannel-1-title">
                <h3>Task</h3>
                <div class="pannel-1-title-option" v-if="isEdit">
                  <a class="btn" href="javascript:void(0);" @click="editProject"
                    >Edit</a
                  >
                </div>
              </div>
              <div class="pannel-1-body project-detail-task">
                <p class="preline" v-html="project.task" />
                <h6>
                  <i class="material-icons-outlined align-middle"
                    >account_balance</i
                  >Client Description:
                </h6>
                <p class="preline" v-html="project.client_description" />
              </div>
              <div v-if="project.roles && project.roles.length > 0">
                <div
                  v-for="(role, index) in project.roles"
                  :key="index"
                  class="relative"
                >
                  <div class="hr"></div>
                  <div class="pannel-1-title">
                    <h3 class="cursor-default">
                      {{ role.title }}
                    </h3>
                    <div class="pannel-1-title-option" v-if="isEdit">
                      <a
                        class="btn"
                        href="javascript:void(0);"
                        @click="editRole(index)"
                        >Edit</a
                      >
                    </div>
                  </div>
                  <div class="pannel-1-body project-detail-task">
                    <p class="preline" v-html="role.requirements" />
                    <p class="inline">
                      <label
                        ><i class="material-icons align-middle">account_box</i
                        >Tech Level</label
                      >
                      <span class="tech_lvl_tag"
                        ><i class="material-icons align-middle">stream</i
                        >{{ role.tech_level }}</span
                      >
                    </p>
                    <p class="inline">
                      <label
                        ><i class="material-icons align-middle">east</i
                        >Engagement Length</label
                      >
                      {{ role.engagement }}
                    </p>
                    <p class="inline">
                      <label
                        ><i class="material-icons-outlined align-middle"
                          >logout</i
                        >Estimated Start</label
                      >
                      {{ role.estimated_start | dateformatFilter("D/M/YYYY") }}
                    </p>
                    <p
                      class="inline"
                      v-if="
                        role.display_client_rate !== null &&
                        role.display_client_rate !== undefined
                      "
                    >
                      <label
                        ><i class="material-icons align-middle"
                          >monetization_on</i
                        >Rate</label
                      >
                      ${{ role.display_client_rate }}/{{
                        role.display_client_rate_type === "monthly"
                          ? "month"
                          : "hour"
                      }}
                    </p>
                    <p
                      class="inline"
                      v-if="
                        role.hours_per_week !== null &&
                        role.hours_per_week !== undefined
                      "
                    >
                      <label
                        ><i class="material-icons align-middle"
                          >perm_contact_calendar</i
                        >Hours Weekly</label
                      >
                      {{ role.hours_per_week ? role.hours_per_week : "" }}/week
                    </p>
                  </div>
                  <div class="deal-size">
                    <p class="font-color-light font-lg">
                      Deal Size<i class="material-icons align-middle"
                        >arrow_drop_down</i
                      >
                    </p>
                    <p
                      v-if="
                        (role.display_client_rate !== null &&
                          role.display_client_rate !== undefined) ||
                        (role.display_client_rate !== null &&
                          role.display_client_rate !== undefined)
                      "
                      class="assuming"
                    >
                      <span
                        >${{
                          role.display_client_rate_type === "monthly"
                            ? role.display_client_rate
                            : Math.floor(
                                role.hours_per_week *
                                  role.display_client_rate *
                                  4
                              )
                        }}</span
                      >
                      /{{
                        role.display_client_rate_type === "monthly"
                          ? "month"
                          : "hour"
                      }}
                    </p>
                    <p class="font-color-lighter font-sm line-height-20">
                      Assuming 4 weeks per month
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="main-flex-1">
            <div v-for="(role, index) in project.roles" :key="index">
              <div v-if="index !== 0" class="hr m-t-l m-b-l"></div>
              <div class="pannel-out-title">
                <h3>{{ role.title }}</h3>
              </div>
              <div
                v-if="
                  showConsultants[role.id] &&
                  showConsultants[role.id].length > 0
                "
              >
                <div
                  class="pannel-1 pannel-1-padding relative action-wrapper"
                  v-for="(consultant, cIndex) in showConsultants[
                    role.id
                  ].filter((item) => {
                    if (project.phase !== 'Operational') {
                      return item.status === 'Submitted';
                    }
                    return true;
                  })"
                  :key="cIndex"
                  :class="{ 'quote-wrapper': consultant.quote }"
                  @click="onConsultantClick(role.id, consultant.id)"
                >
                  <div class="pannel-1-title">
                    <div style="width: 100%">
                      <h3>
                        <div
                          class="use-wrapper"
                          @click="toResume(consultant.id, $event)"
                        >
                          <div class="avatar">
                            <span
                              v-if="!consultant.photo_url || type !== 'allinfo'"
                              >{{
                                (type !== "allinfo"
                                  ? "a"
                                  : consultant.name
                                  ? consultant.name
                                  : consultant.email) | getFirstLetter
                              }}</span
                            >
                            <img v-else :src="consultant.photo_url" alt />
                          </div>
                          <div class="user-name">
                            {{
                              (type === "allinfo"
                                ? consultant.name
                                : "Anonymous") | getShorterName
                            }}
                          </div>
                        </div>
                        <i
                          class="material-icons align-middle font-color-lighter"
                          v-if="
                            (consultant.client_confirm ||
                              consultant.reply === 'yes') &&
                            !(
                              consultant.client_confirm &&
                              consultant.reply === 'yes'
                            )
                          "
                          >check</i
                        >
                        <i
                          class="material-icons align-middle font-color-lighter"
                          v-if="
                            consultant.client_confirm &&
                            consultant.reply === 'yes'
                          "
                          >done_all</i
                        >
                        <i
                          class="material-icons align-middle font-color-green"
                          v-if="consultant.verified"
                          >verified</i
                        >
                        <div class="pannel-1-title-option">
                          <span v-if="consultant.role_rate_to_client"
                            >{{
                              consultant.role_rate_to_client
                                | currencyFilter("$", 2)
                            }}<span>{{
                              consultant.c_rate_type_to_client === "monthly"
                                ? "/month"
                                : "/hour"
                            }}</span></span
                          >
                        </div>
                      </h3>
                    </div>
                  </div>
                  <div class="hr"></div>
                  <div>
                    <div class="pannel-1-body p-b-0">
                      <p>{{ consultant.bio }}</p>
                    </div>
                    <div class="pannel-1-footer">
                      <div>
                        <span class="tech_lvl_tag"
                          ><i class="material-icons align-middle">stream</i
                          >{{ consultant.tech_level }}</span
                        >
                      </div>
                    </div>
                  </div>
                  <CheckinDetail
                    v-if="consultant.status === 'Current Contractor'"
                    :email="consultant.email"
                    :projectId="project.id"
                    :rate="
                      consultant.role_rate
                        ? consultant.role_rate
                        : consultant.rate
                    "
                    :rateToClient="consultant.role_rate_to_client"
                    :rateType="consultant.c_rate_type"
                    :rateTypeToClient="consultant.c_rate_type_to_client"
                    :isPublic="true"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="edit-pannel">
      <edit-pannel v-if="isEdit" v-model="editOpen" title>
        <ProjectPanel
          v-if="editOpen == 1"
          :propsData="project"
          :projectPhaseOptions="projectPhaseOptions"
          @closePanel="closeEditPannel"
        ></ProjectPanel>
        <RolePanel
          v-if="editOpen == 2"
          :propsData="project"
          :roleId="editRoleId"
          :techLevelOptions="techLevelOptions"
          :metroOptions="metroOptions"
          :techWorkTypeOptions="techWorkTypeOptions"
          @closePanel="closeEditPannel"
        ></RolePanel>
      </edit-pannel>
    </transition>
  </div>
</template>

<script>
import { db } from "@/vendor/firebase";
import EditPannel from "@/components/EditPannel";
import OptionMenu from "@/components/OptionMenu";
import NewProjectMessage from "@/components/public/NewProjectMessage.vue";
import ProjectPanel from "./ProjectPanel";
import RolePanel from "./RolePanel";
import Proposal from "./Proposal.vue";
import CheckinDetail from "@/views/admin/ProjectDetail/CheckinDetail.vue";

export default {
  data() {
    return {
      projectId: null,
      type: "anon",
      project: null,
      showConsultants: {},
      consultants: null,
      first: false,
      url: "",
      isEdit: false,
      projectPhases: null,
      projectPhaseOptions: [],
      techLevels: null,
      techLevelOptions: [],
      metros: null,
      metroOptions: [],
      techWorkTypes: null,
      techWorkTypeOptions: [],
      editOpen: false,
    };
  },
  components: {
    NewProjectMessage,
    EditPannel,
    OptionMenu,
    ProjectPanel,
    RolePanel,
    Proposal,
    CheckinDetail,
  },
  watch: {
    editOpenTitle: function (val) {
      this.editOpen = val;
    },
    project: function () {
      if (this.project.is_anon) {
        this.type = "anon";
      }
      this.initShowConsultants();
    },
    consultants: function () {
      this.initShowConsultants();
    },
    projectPhases: function () {
      this.projectPhaseOptions = this.projectPhases.map((item) => ({
        text: item.name,
        value: item.name,
      }));
    },
    techLevels: function () {
      const techLevels = JSON.parse(JSON.stringify(this.techLevels));
      this.techLevelOptions = techLevels
        .sort((a, b) => a.order - b.order)
        .map((item) => ({
          text: item.name,
          value: item.name,
        }));
    },
    metros: function () {
      this.metroOptions = this.metros.map((item) => ({
        text: item.name,
        value: item.name,
      }));
    },
    techWorkTypes: function () {
      const techWorkTypes = JSON.parse(JSON.stringify(this.techWorkTypes));
      this.techWorkTypeOptions = techWorkTypes.map((item) => ({
        text: item.name,
        value: item.name,
      }));
    },
  },
  beforeMount() {
    this.projectId = this.$route.params.id;
    if (this.$route.params.type === "allinfo") {
      this.type = "allinfo";
    } else {
      this.type = "anon";
    }
    this.isEdit = this.$route.params.type === "edit";
    this.first = this.$route.query.first === "true";
    if (this.first) {
      this.url = window.location.href.split("?")[0];
    }
    this.bindData();
  },
  methods: {
    bindData: function () {
      this.$bind("project", db.collection("gigs").doc(this.projectId));
      this.$bind("consultants", db.collection("consultants"));
      if (this.isEdit) {
        this.$bind("projectPhases", db.collection("project_phases"));
        this.$bind("techLevels", db.collection("tech_levels"));
        this.$bind("metros", db.collection("metros"));
        this.$bind("techWorkTypes", db.collection("new_work_types"));
      }
    },
    onCloseMessage: function () {
      this.first = false;
      this.$router.replace({ query: {} });
    },
    toResume: function (id, event) {
      event.stopPropagation();
      const routeData = this.$router.resolve({
        path: `/resume/${id}/${this.type}`,
      });
      window.open(routeData.href, "_blank");
    },
    openEditPannel: function (action, title, isToggle) {
      if (this.editOpen && this.editOpen != action) {
        this.editOpen = action;
        this.emitEditPannel(title);
        return;
      }
      if (isToggle) {
        this.editOpen = this.editOpen ? false : action;
      } else {
        this.editOpen = action;
      }
      this.emitEditPannel(title);
    },
    closeEditPannel: function () {
      this.editOpen = false;
      this.emitEditPannel();
    },
    emitEditPannel: function (title) {
      const param = {
        title: title,
        editOpen: this.editOpen,
      };
      this.$emit("openEditPannelTitle", param);
    },
    editProject: function () {
      this.openEditPannel(1, "Edit Project", true);
    },
    editRole: function (index) {
      this.editRoleId = index;
      this.openEditPannel(2, "Edit Role", true);
    },
    initShowConsultants() {
      if (this.project && this.consultants) {
        this.showConsultants = {};
        const selectedConsultants = this.project.selected_consultants;
        if (selectedConsultants) {
          selectedConsultants.forEach((item) => {
            const roleId = item.role_id;
            const consultants = item.consultants;
            if (roleId && consultants) {
              const slectedConsultants = [];
              consultants.forEach((item) => {
                const consultant = this.consultants.find(
                  (c) => c.id === item.id
                );
                if (consultant) {
                  if (this.project.phase === "Operational") {
                    if (item.status === "Current Contractor") {
                      slectedConsultants.push({ ...consultant, ...item });
                    }
                  } else {
                    slectedConsultants.push({ ...consultant, ...item });
                  }
                }
              });
              slectedConsultants.sort(this.sortRoleStatus);
              this.showConsultants[roleId] = slectedConsultants;
            }
          });
        }
        if (this.project.roles && this.showConsultants) {
          this.project.roles.forEach((role) => {
            if (
              role.rate_to_client !== null &&
              role.rate_to_client !== undefined
            ) {
              role.display_client_rate = role.rate_to_client;
              role.display_client_rate_type = role.rate_type;
            }
            const sc = this.showConsultants[role.id];
            if (sc) {
              const checkedConsultant = sc.find(
                (cc) => cc.status === "Current Contractor"
              );
              if (checkedConsultant) {
                role.consultant_rate = checkedConsultant.rate;
                role.c_rate_type = checkedConsultant.c_rate_type;
                role.c_rate_type_to_client =
                  checkedConsultant.c_rate_type_to_client;
                role.role_rate = checkedConsultant.role_rate;
                role.role_rate_to_client =
                  checkedConsultant.role_rate_to_client;
                role.display_client_rate = null;
                if (
                  role.role_rate_to_client !== null &&
                  role.role_rate_to_client !== undefined
                ) {
                  role.display_client_rate = role.role_rate_to_client;
                  role.display_client_rate_type = role.c_rate_type_to_client;
                } else if (
                  role.rate_to_client !== null &&
                  role.rate_to_client !== undefined
                ) {
                  role.display_client_rate = role.rate_to_client;
                  role.display_client_rate_type = role.rate_type;
                } else if (
                  role.role_rate !== null &&
                  role.role_rate !== undefined
                ) {
                  role.display_client_rate = role.role_rate * 1.35;
                  role.display_client_rate_type = "hourly";
                } else if (
                  role.consultant_rate !== null &&
                  role.consultant_rate !== undefined
                ) {
                  role.display_client_rate = role.consultant_rate * 1.35;
                  role.display_client_rate_type = "hourly";
                }
              }
            }
          });
        }
      }
    },
  },
};
</script>


<style scoped>
.wrapper {
  flex: 1;
  display: flex;
  max-width: 1440px;
  margin: 0 auto;
}
.relative {
  position: relative;
}
.no-hover > div:hover {
  background: #fff;
}
.mt {
  margin-top: 30px;
  margin-right: 10px;
}
.mt-5 {
  margin-top: 5px;
  margin-right: 5px;
}
.check-button {
  width: 30px;
  height: 30px;
  cursor: pointer;
  padding-top: 8px;
  font-weight: 900;
  color: #cccccc;
}
.preline {
  white-space: pre-line;
}
.name-wrapper {
  display: flex;
}
.ml {
  margin-left: 5px;
}
.cursor-pointer {
  cursor: pointer;
}
.files-wrapper {
  width: 100%;
  padding: 20px;
  border-top: 1px solid var(--border-grey-lightest);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.files-wrapper > label {
  font-family: avenir-next-block;
  font-size: 12px;
}
.files-wrapper > *:not(:first-child) {
  margin-top: 4px;
}
.verified-tag {
  position: absolute;
  top: 0;
  right: 0;
}
.verified-tag::before,
.verified-tag::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  border-color: transparent;
  border-style: solid;
}

.verified-tag::before {
  border-width: 16px;
  border-right-color: transparent;
  border-top-color: transparent;
}

.verified-tag::after {
  border-width: 16px;
  border-right-color: #437512;
  border-top-color: #437512;
}
.relative {
  position: relative;
}
.flex-wrapper {
  display: flex;
  align-items: center;
}
.consultant-action {
  display: none;
  position: absolute;
  right: 15px;
  top: 15px;
  font-size: var(--font-size-l);
}
.action-wrapper {
  cursor: pointer;
}
.action-wrapper:hover .consultant-action {
  display: block;
}
.quote-wrapper {
  border: 2px solid #0085ff;
  box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.1), 0px 3px 3px rgba(0, 0, 0, 0.06),
    0px 3px 4px rgba(0, 0, 0, 0.08);
}
.use-wrapper {
  display: flex;
  align-items: center;
}
.user-name {
  color: var(--blue-light);
}
.user-name:hover {
  text-decoration: underline;
}
.new-project-message-wrapper {
  margin: var(--margin-3l);
}
</style>
